var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartMi2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    id: "heart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2abba",
    d: "M0 0c0 5.45-4.418 9.868-9.867 9.868-3.308 0-6.227-1.633-8.018-4.129-1.79 2.496-4.71 4.129-8.017 4.129-5.45 0-9.868-4.418-9.868-9.868 0-.772.098-1.52.266-2.241 1.371-8.512 10.835-17.494 17.619-19.96 6.783 2.466 16.249 11.448 17.617 19.96C-.098-1.52 0-.772 0 0",
    transform: "translate(36.885 25.166)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a70",
    d: "M0 0a7.405 7.405 0 0 1-7.405 7.406 7.392 7.392 0 0 1-6.018-3.099 7.39 7.39 0 0 1-6.017 3.099A7.406 7.406 0 0 1-26.846 0c0-.579.074-1.141.199-1.681 1.029-6.389 8.132-13.131 13.224-14.981C-8.332-14.812-1.228-8.07-.2-1.682-.073-1.141 0-.579 0 0",
    transform: "translate(32.423 23.628)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb1a34",
    d: "M0 0a5.071 5.071 0 0 1-5.07 5.072 5.058 5.058 0 0 1-4.121-2.123 5.061 5.061 0 0 1-4.121 2.123A5.072 5.072 0 0 1-18.384 0c0-.397.051-.781.136-1.151.705-4.376 5.57-8.992 9.057-10.26C-5.706-10.143-.84-5.527-.137-1.152-.05-.781 0-.397 0 0",
    transform: "translate(28.191 22.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartMi2);
export default __webpack_public_path__ + "static/media/heart-mi2.3d220beac19d52bbf7db1d674e299da7.svg";
export { ForwardRef as ReactComponent };